import { useState } from "react";
import { Card, PageHeader, Input, Select, Btn } from "../../components/shared/UIComponents";
import { SocietyAPI, AdminMgmtAPI } from "../../services/api";

export function RegisterSociety() {
  const [form, setForm] = useState({ societyName:'', registrationNumber:'', phone:'', email:'', gstNumber:'', panNumber:'', state:'Maharashtra', city:'Mumbai', location:'', address:'', pinCode:'', totalResidentialFlats:'', totalCommercialUnits:'', wingDetails:'' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]       = useState(null);

  const f = (key) => ({ value: form[key], onChange: e => setForm(p=>({...p,[key]:e.target.value})) });

  const handleSubmit = async () => {
    setSaving(true); setMsg(null);
    try {
      await SocietyAPI.register(form);
      setMsg({ type:'success', text:'Society registered successfully!' });
      setForm({ societyName:'', registrationNumber:'', phone:'', email:'', gstNumber:'', panNumber:'', state:'Maharashtra', city:'Mumbai', location:'', address:'', pinCode:'', totalResidentialFlats:'', totalCommercialUnits:'', wingDetails:'' });
    } catch(e) { setMsg({ type:'error', text: e.message }); }
    finally { setSaving(false); }
  };

  return (
    <Card>
      <PageHeader title="Register New Society" />
      <div style={{ padding: 24 }}>
        {msg && <div style={{ padding:"10px 14px", borderRadius:8, marginBottom:16, fontSize:13, background: msg.type==='success'?'#e8f5e9':'#fce8e6', color: msg.type==='success'?'#2e7d32':'#c62828' }}>{msg.text}</div>}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:16 }}>
          <Input label="Society Name" placeholder="Enter Society Name" {...f('societyName')} />
          <Input label="Registration Number" placeholder="Enter Reg No" {...f('registrationNumber')} />
          <Input label="Registered Mobile No" placeholder="Enter Mobile No" {...f('phone')} />
          <Input label="Registered Email" placeholder="Enter Email" {...f('email')} />
          <Input label="GST Number" placeholder="Enter GST No" {...f('gstNumber')} />
          <Input label="PAN Number" placeholder="Enter PAN No" {...f('panNumber')} />
          <Select label="State" options={["Maharashtra","Delhi","Gujarat","Karnataka","Tamil Nadu","Rajasthan"]} {...f('state')} />
          <Select label="City" options={["Mumbai","Pune","Navi Mumbai","Thane","Nashik","Nagpur"]} {...f('city')} />
          <Input label="Location" placeholder="Enter Location" {...f('location')} />
          <Input label="Address" placeholder="Enter Address" style={{ gridColumn:"span 2" }} {...f('address')} />
          <Input label="Pin Code" placeholder="Enter Pin Code" {...f('pinCode')} />
          <Input label="Total Residential Flats" placeholder="e.g. 100" {...f('totalResidentialFlats')} />
          <Input label="Total Commercial Units" placeholder="e.g. 10" {...f('totalCommercialUnits')} />
          <Input label="Wing/Block Details" placeholder="e.g. A, B, C" {...f('wingDetails')} />
        </div>
        <div style={{ marginTop:20, display:"flex", gap:10 }}>
          <Btn onClick={handleSubmit} disabled={saving}>{saving ? 'Saving…' : 'Register Society'}</Btn>
          <Btn bg="#42a5f5" onClick={() => setForm(p=>({...p}))}>Refresh</Btn>
        </div>
      </div>
    </Card>
  );
}

export function ChangePassword({ adminUser }) {
  const [form, setForm] = useState({ oldPassword:'', newPassword:'', confirmPassword:'' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]       = useState(null);

  const handleSubmit = async () => {
    if (form.newPassword !== form.confirmPassword) { setMsg({ type:'error', text:'Passwords do not match' }); return; }
    setSaving(true); setMsg(null);
    try {
      await AdminMgmtAPI.changePassword({ oldPassword: form.oldPassword, newPassword: form.newPassword });
      setMsg({ type:'success', text:'Password changed successfully!' });
      setForm({ oldPassword:'', newPassword:'', confirmPassword:'' });
    } catch(e) { setMsg({ type:'error', text: e.message }); }
    finally { setSaving(false); }
  };

  return (
    <Card>
      <PageHeader title="Change Password" />
      <div style={{ padding: 24 }}>
        {msg && <div style={{ padding:"10px 14px", borderRadius:8, marginBottom:16, fontSize:13, background: msg.type==='success'?'#e8f5e9':'#fce8e6', color: msg.type==='success'?'#2e7d32':'#c62828' }}>{msg.text}</div>}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:18 }}>
          <Input label="Name" defaultValue={adminUser?.name || ""} readOnly />
          <Input label="Email" defaultValue={adminUser?.email || ""} readOnly />
          <Input label="Current Password" type="password" placeholder="Enter current password" value={form.oldPassword} onChange={e=>setForm(p=>({...p,oldPassword:e.target.value}))} />
          <Input label="New Password" type="password" placeholder="Enter new password" value={form.newPassword} onChange={e=>setForm(p=>({...p,newPassword:e.target.value}))} />
          <Input label="Confirm Password" type="password" placeholder="Confirm new password" value={form.confirmPassword} onChange={e=>setForm(p=>({...p,confirmPassword:e.target.value}))} />
        </div>
        <div style={{ marginTop:20, display:"flex", gap:10 }}>
          <Btn onClick={handleSubmit} disabled={saving}>{saving?'Saving…':'Save'}</Btn>
        </div>
      </div>
    </Card>
  );
}

export function EventManager() {
  return (
    <Card>
      <PageHeader title="Event Details" />
      <div style={{ padding: 24 }}>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
          <Select label="Event Category" options={["Sports","Cultural","Meeting","Festival","Other"]} />
          <Input label="Event Title" placeholder="Enter Title" />
          <Input label="Event Start Date" type="date" />
          <Input label="Event End Date" type="date" />
          <div style={{ gridColumn:"span 2" }}>
            <label style={{ display:"block", fontSize:11, fontWeight:600, color:"#78909c", marginBottom:5, textTransform:"uppercase" }}>Description</label>
            <textarea placeholder="Enter Event Description" style={{ width:"100%", padding:"9px 12px", border:"1.5px solid #e0e0e0", borderRadius:8, fontSize:13, boxSizing:"border-box", height:100 }} />
          </div>
          <div style={{ gridColumn:"span 2" }}>
            <label style={{ display:"block", fontSize:11, fontWeight:600, color:"#78909c", marginBottom:5, textTransform:"uppercase" }}>Upload Banner Image</label>
            <input type="file" accept="image/*" style={{ fontSize:13, padding:"7px", border:"1.5px solid #e0e0e0", borderRadius:8 }} />
          </div>
          <div style={{ gridColumn:"span 2" }}><Btn>Save Event</Btn></div>
        </div>
      </div>
    </Card>
  );
}

export function UploadMembersData() {
  return (
    <Card>
      <PageHeader title="Upload Members Excel File" />
      <div style={{ padding: 24 }}>
        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:20 }}>
          <div><label style={{ fontSize:13, color:"#546e7a", marginRight:10 }}>Download CSV File Template</label><Btn bg="#1565c0" style={{ padding:"7px 16px" }}>Download</Btn></div>
          <div><label style={{ fontSize:13, color:"#546e7a", marginRight:10 }}>Click Here To View Members Master</label><Btn bg="#0f9d58" style={{ padding:"7px 16px" }}>View</Btn></div>
        </div>
        <div style={{ marginBottom:16 }}>
          <label style={{ display:"block", fontSize:12, fontWeight:600, color:"#78909c", marginBottom:6 }}>Select CSV File</label>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <input type="file" accept=".csv" style={{ fontSize:13, padding:"8px", border:"1.5px solid #e0e0e0", borderRadius:8 }} />
            <span style={{ color:"#f57c00", fontSize:13, fontWeight:600 }}>Max File Size : 8MB</span>
          </div>
        </div>
        <Btn>Upload</Btn>
      </div>
    </Card>
  );
}

export function UploadVehicleData() {
  return (
    <Card>
      <PageHeader title="Upload Members Vehicle Excel File" />
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom:16 }}><label style={{ fontSize:13, color:"#546e7a", marginRight:10 }}>Download CSV File Template</label><Btn bg="#1565c0" style={{ padding:"7px 16px" }}>Download</Btn></div>
        <div style={{ marginBottom:16 }}>
          <label style={{ display:"block", fontSize:12, fontWeight:600, color:"#78909c", marginBottom:6 }}>Select CSV File</label>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <input type="file" accept=".csv" style={{ fontSize:13, padding:"8px", border:"1.5px solid #e0e0e0", borderRadius:8 }} />
            <span style={{ color:"#f57c00", fontSize:13, fontWeight:600 }}>Max File Size : 8MB</span>
          </div>
        </div>
        <Btn>Upload</Btn>
      </div>
    </Card>
  );
}

export function ComingSoon({ title }) {
  return (
    <Card>
      <PageHeader title={title} />
      <div style={{ padding:60, textAlign:"center", color:"#90a4ae" }}>
        <div style={{ fontSize:52, marginBottom:12 }}>🏗️</div>
        <p style={{ fontSize:15 }}>{title} module is ready to be configured.</p>
        <p style={{ fontSize:13 }}>Content will appear here when connected to the backend API.</p>
      </div>
    </Card>
  );
}

export default RegisterSociety;
